import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCubes } from "@fortawesome/free-solid-svg-icons";
import { faBoxCircleCheck, faLink, faMobileScreenButton, faTruckContainer } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Grid from "@mui/material/Grid";
import { notification } from "antd";
import React, { useRef, useState } from "react";
import { globalAppConfig } from "../../config";
import Helper from "../../Helper";
import InstallPLOTModal from "../Project/installPLOTModal";
import ContactSupport from "../Support/ContactSupport";
import Modal from "../UI/Modal";

interface FeedbackHelpModalProps {
    showModal: boolean;
    onClose: () => void;
}

const FeedbackHelpModal: React.FC<FeedbackHelpModalProps> = ({ showModal, onClose }) => {
    const formRef = useRef<any>(undefined);
    const [userInfo, setUserInfo] = useState({
        email: null,
        fullname: null,
        message: null,
        url: window.location.href.toString(),
    });
    const [installPLOTModalVisible, setInstallPLOTModalVisible] = useState(false);

    const handleUpdate = (e: React.ChangeEvent<HTMLInputElement>) => {
        setUserInfo({
            ...userInfo,
            [e.target.id]: e.target.value,
        });
    };

    const onFinish = (e) => {
        e.preventDefault();
        const url = "/me/feedback";
        const options = {
            method: "post",
            body: JSON.stringify(userInfo),
        };
        Helper.plotFetch(url, options, true)
            .then((data) => {
                if (data.ok) {
                    return data.json();
                }
                throw new Error("Network error.");
            })
            .then(() => {
                notification.success({
                    message: "Feedback Submitted",
                    description: "Thank you for submitting your feedback!",
                    duration: globalAppConfig.NOTIFICATION_DURATION,
                });

                onClose();
            })
            .catch((err) => {
                notification.error({
                    message: "Failed to Share Feedback",
                    description: "The feedback could not be shared: " + err,
                    duration: globalAppConfig.NOTIFICATION_DURATION,
                });
            });
    };

    return (
        <>
            <Modal
                destroyOnHidden={true}
                title="Get Help or Share Feedback"
                open={showModal}
                onCancel={onClose}
                width={400}
                footer={null}
            >
                <div style={{ textAlign: "center" }}>
                    {/* <p>Check out our Quick Start Guide and other helpful links for info on using PLOT</p> */}
                    <p className="text-center text-lg font-plot-oswald">Check out our help articles</p>
                    <Grid container spacing={2} style={{ marginTop: "0.1em" }}>
                        <Grid size={{ xs: 6 }}>
                            <a
                                href="https://intercom.help/plotjobsites/en/collections/15671831-1-getting-started"
                                target="_blank"
                                rel="noreferrer noopener"
                            >
                                <button className="plot-button alternate-button block-button select-none" type="button">
                                    <FontAwesomeIcon icon={faBoxCircleCheck} />
                                    <span style={{ marginLeft: "5px" }}>Getting Started</span>
                                </button>
                            </a>
                        </Grid>
                        <Grid size={{ xs: 6 }}>
                            <a
                                href="https://intercom.help/plotjobsites/en/collections/15671832-2-delivery-logistics-tool"
                                target="_blank"
                                rel="noreferrer noopener"
                            >
                                <button className="plot-button alternate-button block-button select-none" type="button">
                                    <FontAwesomeIcon icon={faTruckContainer as IconProp} />
                                    <span style={{ marginLeft: "5px" }}>Deliveries</span>
                                </button>
                            </a>
                        </Grid>
                        <Grid size={{ xs: 6 }}>
                            <a
                                href="https://intercom.help/plotjobsites/en/collections/15671834-3-procurement-scheduling-tool"
                                target="_blank"
                                rel="noreferrer noopener"
                            >
                                <button className="plot-button alternate-button block-button select-none" type="button">
                                    <FontAwesomeIcon icon={faCubes as IconProp} />
                                    <span style={{ marginLeft: "5px" }}>Procurement</span>
                                </button>
                            </a>
                        </Grid>
                        <Grid size={{ xs: 6 }}>
                            <a
                                href="https://intercom.help/plotjobsites/en/collections/15671838-5-integrations"
                                target="_blank"
                                rel="noreferrer noopener"
                            >
                                <button className="plot-button alternate-button block-button select-none" type="button">
                                    <FontAwesomeIcon icon={faLink as IconProp} />
                                    <span style={{ marginLeft: "5px" }}>Integrations</span>
                                </button>
                            </a>
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <button
                                onClick={() => {
                                    setInstallPLOTModalVisible(!installPLOTModalVisible);
                                }}
                                className="plot-button alternate-button block-button select-none"
                                type="button"
                            >
                                <FontAwesomeIcon icon={faMobileScreenButton as IconProp} />
                                <span style={{ marginLeft: "5px" }}>Mobile App Download and Training</span>
                            </button>
                            <InstallPLOTModal
                                visible={installPLOTModalVisible}
                                hideModal={() => {
                                    setInstallPLOTModalVisible(!installPLOTModalVisible);
                                }}
                            />
                        </Grid>
                    </Grid>

                    <hr
                        style={{
                            width: "100%",
                            marginTop: "10px",
                            marginBottom: "10px",
                        }}
                    />
                </div>
                <ContactSupport onClose={onClose} />
            </Modal>
        </>
    );
};

export default FeedbackHelpModal;
